import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import styles from "../styles";
import { TextField, CheckBox } from "components/support";
import Tooltip from "material-ui-next/Tooltip";
import Icon from "material-ui-next/Icon";

class CompanyIntegrationsNappView extends Component {
  constructor(props) {
    super(props);
    props.viewModel.company = props.company;
  }

  render() {
    const { presenter } = this.props;
    const { napp } = this.props.company.integrations;
    return (
      <div className="grid-container mv-sm">
        <Typography type="headline">Napp</Typography>
        <hr />
        <Row>
          <Col xs={12}>
            <div style={styles.informations}>
              <div>
                <CheckBox
                  checked={napp.enabled}
                  label="Ativar Integração"
                  style={styles.checkBox}
                  onCheck={checked => presenter.onEnabledChange(checked)}
                />
              </div>
              <div style={styles.tooltip}>
                <Tooltip
                  key="tooltip-right"
                  title="Desative e ative sua integração quando quiser, sem perder seus dados"
                  placement="right"
                >
                  <Icon style={styles.icon}>info</Icon>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <TextField
              fullWidth
              label="URL"
              value={napp.url}
              onChange={(_, value) => (napp.url = value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <TextField
              fullWidth
              label="Login"
              value={napp.user}
              onChange={(_, value) => (napp.user = value)}
            />
          </Col>
          <Col xs={12} lg={6}>
            <TextField
              fullWidth
              label="Senha"
              type="password"
              value={napp.password}
              onChange={(_, value) => (napp.password = value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <TextField
              fullWidth
              label="ID da Empresa"
              value={napp.id}
              onChange={(_, value) => (napp.id = value)}
            />
          </Col>
          <Col xs={12} lg={6}>
            <TextField
              fullWidth
              label="Nome da Empresa"
              value={napp.name}
              onChange={(_, value) => (napp.name = value)}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default CompanyIntegrationsNappView;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/napp/view.jsx